export class TblFAList {
  id?: number;
  employeeId: string;
  faList: FAListData;

  constructor(employeeId: string, faList: FAListData) {
    this.employeeId = employeeId;
    this.faList = faList;
  }
}

export class FAListData {
  Name: string;
  Domicile: string;
}
